import { createAction } from 'redux-actions';
import { PapiGallection } from '@wix/da-papi-types';
import { actionKey } from '../constants';
import { PresetsPromptType, PresetsInitResponse } from '../types';

export const presetsInitFetch = createAction(
  `${actionKey}.PRESETS_INIT_FETCH`,
  (presetId: number | null) => ({ presetId })
);

export const presetsInitSuccess = createAction(
  `${actionKey}.PRESETS_INIT_SUCCESS`,
  (payload: PresetsInitResponse) => payload
);

export const presetsInitError = createAction(
  `${actionKey}.PRESETS_INIT_ERROR`,
  () => ({})
);

export const presetsSave = createAction(
  `${actionKey}.PRESETS_SAVE`,
  (data: any, dismissPrompt: boolean, nextPreset: number | null) => ({
    data,
    dismissPrompt,
    nextPreset,
  })
);

export const presetsSaveSuccess = createAction(
  `${actionKey}.PRESETS_SAVE_SUCCESS`,
  () => ({})
);

export const presetsSetActive = createAction(
  `${actionKey}.PRESETS_SET_ACTIVE`,
  (presetId: number) => ({ presetId })
);

export const presetsPromptShow = createAction(
  `${actionKey}.PRESETS_PROMPT_SHOW`,
  (type: PresetsPromptType) => ({ type })
);

export const presetsPromptSubmit = createAction(
  `${actionKey}.PRESETS_PROMPT_SUBMIT`,
  (type: PresetsPromptType, data: any) => ({ type, data })
);

export const presetsPromptDismiss = createAction(
  `${actionKey}.PRESETS_PROMPT_DISMISS`,
  () => ({})
);

export const presetsCreate = createAction(
  `${actionKey}.PRESETS_CREATE`,
  (data: any) => ({ data })
);

export const presetsDelete = createAction(
  `${actionKey}.PRESETS_DELETE`,
  (presetId: number) => ({ presetId })
);

export const presetsLoadGalleriesSuccess = createAction(
  `${actionKey}.PRESETS_LOAD_GALLERIES_SUCCESS`,
  (galleries: PapiGallection[]) => ({ galleries })
);
